import React from 'react';
import PropTypes from 'prop-types';

import styles from './PreviewEdit.module.css';

export default class PreviewEdit extends React.PureComponent {
    static propTypes = {
        onClick: PropTypes.func.isRequired,
    }

    render() {
        return (
            <div className={styles.base} onClick={this.props.onClick} />
        )
    }
}
